// import { useState } from "react";
// import styles from "./VenueSpaceGallery.module.css";

// export default function VenueSpaceGallery({ spaces }) {

//   const images = spaces.flatMap(space =>
//     (space.images || []).map(img => ({
//       image: img.image,
//       name: space.name,
//     }))
//   );

//   const [current, setCurrent] = useState(0);

//   if (images.length === 0) return null;

//   const prev = () => {
//     setCurrent(prev =>
//       prev === 0 ? images.length - 1 : prev - 1
//     );
//   };

//   const next = () => {
//     setCurrent(prev =>
//       prev === images.length - 1 ? 0 : prev + 1
//     );
//   };

//   return (
//     <section className={styles.section}>

//       <h2 className={styles.heading}>
//         Venue Space Gallery
//       </h2>

//       <div className={styles.carousel}>

//         <button
//           className={`${styles.arrow} ${styles.left}`}
//           onClick={prev}
//         >
//           &#10094;
//         </button>

//         <div className={styles.imageWrapper}>

//           <img
//             src={images[current].image}
//             alt={images[current].name}
//             className={styles.image}
//           />

//           <div className={styles.overlay}>
//             {images[current].name}
//           </div>

//         </div>

//         <button
//           className={`${styles.arrow} ${styles.right}`}
//           onClick={next}
//         >
//           &#10095;
//         </button>

//       </div>

//     </section>
//   );
// }


import { useState, useEffect, useMemo } from "react";
import styles from "./VenueSpaceGallery.module.css";

export default function VenueSpaceGallery({ spaces = [] }) {
  const images = useMemo(
    () =>
      spaces.flatMap((space) =>
        (space.images || [])
          .filter((img) => img.image)
          .map((img) => ({
            image: img.image,
            name: space.name,
          }))
      ),
    [spaces]
  );

  const [current, setCurrent] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  // Keep current index valid when images change
  useEffect(() => {
    if (current >= images.length) {
      setCurrent(0);
    }
  }, [images.length, current]);

  const prev = () => {
    setCurrent((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const next = () => {
    setCurrent((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  // Keyboard navigation and body scroll lock
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }

      if (e.key === "ArrowLeft" && images.length > 1) {
        setCurrent((prev) =>
          prev === 0 ? images.length - 1 : prev - 1
        );
      }

      if (e.key === "ArrowRight" && images.length > 1) {
        setCurrent((prev) =>
          prev === images.length - 1 ? 0 : prev + 1
        );
      }
    };

    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, images.length]);

  // Conditional return after all hooks
  if (images.length === 0) return null;

  return (
    <>
      {/* Main Gallery */}
      <section className={styles.section}>
     

        <div className={styles.carousel}>
          {images.length > 1 && (
            <button
              type="button"
              className={`${styles.arrow} ${styles.left}`}
              onClick={prev}
              aria-label="Previous image"
            >
              &#10094;
            </button>
          )}

          <div
            className={styles.imageWrapper}
            onClick={() => setIsOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setIsOpen(true);
              }
            }}
            aria-label="Open image fullscreen"
          >
            <img
              src={images[current].image}
              alt={images[current].name}
              className={styles.image}
            />

            <div className={styles.overlay}>
              <span>{images[current].name}</span>

              <span className={styles.viewLabel}>
                View Fullscreen
              </span>
            </div>
          </div>

          {images.length > 1 && (
            <button
              type="button"
              className={`${styles.arrow} ${styles.right}`}
              onClick={next}
              aria-label="Next image"
            >
              &#10095;
            </button>
          )}
        </div>

        {images.length > 1 && (
          <div className={styles.counter}>
            {current + 1} / {images.length}
          </div>
        )}
      </section>

      {/* Fullscreen Lightbox */}
      {isOpen && (
        <div
          className={styles.lightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Venue space image gallery"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            type="button"
            className={styles.closeButton}
            onClick={closeLightbox}
            aria-label="Close gallery"
          >
            &times;
          </button>

          {/* Previous */}
          {images.length > 1 && (
            <button
              type="button"
              className={`${styles.lightboxArrow} ${styles.lightboxLeft}`}
              onClick={(e) => {
                e.stopPropagation();
                prev();
              }}
              aria-label="Previous image"
            >
              &#10094;
            </button>
          )}

          {/* Fullscreen Image */}
          <div
            className={styles.lightboxContent}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={images[current].image}
              alt={images[current].name}
              className={styles.fullImage}
            />

            <div className={styles.lightboxInfo}>
              <span>{images[current].name}</span>

              <span>
                {current + 1} / {images.length}
              </span>
            </div>
          </div>

          {/* Next */}
          {images.length > 1 && (
            <button
              type="button"
              className={`${styles.lightboxArrow} ${styles.lightboxRight}`}
              onClick={(e) => {
                e.stopPropagation();
                next();
              }}
              aria-label="Next image"
            >
              &#10095;
            </button>
          )}
        </div>
      )}
    </>
  );
}
